import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { initOtel } from './app/core/telemetry/otel-init';

// OTel は bootstrapApplication より前に初期化する。
// これにより document-load span（初期ページロードの Navigation Timing）を bootstrap 前から
// 捕捉でき、ZoneContextManager が zone.js に相乗りして以降の非同期処理へ active span を伝播する。
// mock 環境（environment.useMock: true）では initOtel 内部で早期 return しスキップされる。
initOtel();

bootstrapApplication(App, appConfig).catch((err: unknown) => {
  console.error(err);
});
